let fetchToReturn = null;

if (global.location && global.location.href) {
  const { fetch: fetchPolyfill } = require('whatwg-fetch');
  fetchToReturn = fetchPolyfill;
} else {
  fetchToReturn = require('node-fetch');
}

module.exports.fetch = fetchToReturn;
